import { useEffect } from 'react';
import socket, { joinClienteRooms } from 'shared/socket';

export function useSocketCliente(clienteId, empresaId, pedidoIdRef, onPedidoActualizado, mostrarToast) {
  useEffect(() => {
    if (!clienteId) return;

    if (!socket.connected) socket.connect();

    const onConnect = () => {
      let slug = '';
      let sessionId = '';
      try {
        slug = localStorage.getItem('agorax_empresa_slug') || '';
        if (slug) sessionId = localStorage.getItem(`agorax_session_${slug}`) || '';
      } catch (e) {
        slug = '';
      }
      joinClienteRooms(socket, { idcliente: clienteId, empresaId, sessionId });
    };

    const handlePedidoActualizado = (data) => {
      if (
        data.pedido_id &&
        pedidoIdRef.current &&
        parseInt(data.pedido_id) === parseInt(pedidoIdRef.current)
      ) {
        onPedidoActualizado(data);
      }
    };

    const onNuevoMensaje = (data) => {
      if (data.autor === 'asesor' || data.autor === 'sistema') {
        mostrarToast(data.mensaje?.substring(0, 80) || 'Tienes un nuevo mensaje');
      }
    };

    socket.on('connect', onConnect);
    socket.on('pedido_actualizado', handlePedidoActualizado);
    socket.on('nuevo_mensaje', onNuevoMensaje);

    if (socket.connected) onConnect();

    return () => {
      socket.off('connect', onConnect);
      socket.off('pedido_actualizado', handlePedidoActualizado);
      socket.off('nuevo_mensaje', onNuevoMensaje);
    };
  }, [clienteId, empresaId, pedidoIdRef, onPedidoActualizado, mostrarToast]);
}
